module.exports = __webpack_public_path__ + "img/logo.f7b87fca.svg";